module.exports = __webpack_public_path__ + "static/img/logo1.ac91112.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/logo1.png
// module id = 47WN
// module chunks = 1